import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment.development';
import { ResponseDefault } from '../../core/models/response-default';
import { Product } from '../../core/models/product';
import { DataCategories } from '../../core/models/categories';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private http: HttpClient) { }
  postAllProduct(filter: any, url: string) {
    return this.http.post<Product>(`${environment.api}product/${url}`, filter);
  }
  getAllBrand() {
    return this.http.get<DataCategories>(`${environment.api}categories/all`).pipe(map((res) => res.data.filter((brand) => brand.type === '2')));
  }
  getDetailsProduct(permalink: string, admin: number) {
    return this.http.get<Product>(`${environment.api}product/${permalink}`, { params: { admin } });
  }
  validateProduct(body: any) {
    return this.http.post<{ validate: boolean }>(`${environment.api}product/validate-stock`, body);
  }
  updateProduct(body: any) {
    return this.http.post<ResponseDefault>(`${environment.api}product/update-stock`, body);
  }
  reStockProduct(body: any) {
    return this.http.post<Product>(`${environment.api}product/re-stock`, body);
  }
  getProductSku(id) {
    return this.http.get<ResponseDefault>(`${environment.api}product/sku/${id}`);
  }
  postInventoryUpdate(body: any) {
    return this.http.post<ResponseDefault>(`${environment.api}stripe/manual-sale`, body);
  }
}
